"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNextFocusedOption = void 0;
var _react = require("react");
var useNextFocusedOption = exports.useNextFocusedOption = function useNextFocusedOption(_ref) {
  var options = _ref.options,
    focusedOption = _ref.focusedOption,
    getOptionValue = _ref.getOptionValue;
  return (0, _react.useCallback)(function (direction) {
    if (!options.length || !focusedOption) return;
    var nextFocus = 0;
    var focusedIndex = options.findIndex(function (opt) {
      return getOptionValue(opt) === getOptionValue(focusedOption);
    });
    if (direction === 'up') {
      nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
    } else if (direction === 'down') {
      nextFocus = (focusedIndex + 1) % options.length;
    } else if (direction === 'last') {
      nextFocus = options.length - 1;
    } else if (direction === 'first') {
      nextFocus = 0;
    }
    return options[nextFocus];
  }, [options, focusedOption]);
};